import { SET_EDITOR_VERTICES_TYPE, SET_EDITOR_ANCHORS_TYPE, SET_EDITOR_STATE, RESET_EDITOR_STATE } from './actions';
import { mergeDeep } from '../../../services/helper.service';

const initState = {
  vertices: {
    type: null
  },
  anchors: {
    type: null
  }
};

const editor = (state = initState, action) => {
  switch (action.type) {
    case RESET_EDITOR_STATE: {
      return initState;
    }
    case SET_EDITOR_STATE: {
      return action.state;
    }
    case SET_EDITOR_VERTICES_TYPE: {
      return mergeDeep({}, state, {
        vertices: {
          type: action.value
        }
      });
    }

    case SET_EDITOR_ANCHORS_TYPE: {
      return mergeDeep({}, state, {
        anchors: {
          type: action.value
        }
      });
    }
    default: {
      return state;
    }
  }
};

export default editor;



// WEBPACK FOOTER //
// ./src/reducers/selectors/editor/index.js